
export const LeadsGender = {
    Male: "Male",
    Female: "Female",
    NonBinary: "Non-binary"
}

export const optionsRelationToPrimaryDriver = [
    { label: "Applicant", value: "Applicant" },
    { label: "Spouse", value: "Spouse" },
    { label: "Child", value: "Child" },
    { label: "Other", value: "Other" },
    { label: "Parent", value: "Parent" },
    { label: "Sibling", value: "Sibling" },
    { label: "Grandchild", value: "Grandchild" },
    { label: "Grandparent", value: "Grandparent" },
];

export const optionsPropertyType = [
    { label: "Apartment", value: "Apartment" },
    { label: "Condominium", value: "Condominium" },
    { label: "Duplex", value: "Duplex" },
    { label: "Mobile Home", value: "Mobile Home" },
    { label: "Multi Family Home", value: "Multi Family Home" },
    { label: "Single Family Home", value: "Single Family Home" },
    { label: "Townhome", value: "Townhome" },
]

export const optionsLeadEducation = [
    {
        "id": 1,
        "label": "Some College",
        "value": "SomeCollege"
    },
    {
        "id": 2,
        "label": "High School Diploma",
        "value": "HighSchoolDiploma"
    },
    {
        "id": 3,
        "label": "Bachelors Degree",
        "value": "BachelorsDegree"
    },
    {
        "id": 4,
        "label": "Associate Degree",
        "value": "AssociateDegree"
    },
    {
        "id": 5,
        "label": "GED",
        "value": "GED"
    },
    {
        "id": 6,
        "label": "Some Or No High School",
        "value": "SomeOrNoHighSchool"
    },
    {
        "id": 6,
        "label": "Masters Degree",
        "value": "MastersDegree"
    },
    {
        "id": 6,
        "label": "Trade Vocational School",
        "value": "TradeVocationalSchool"
    },
    {
        "id": 6,
        "label": "Doctorate Degree",
        "value": "DoctorateDegree"
    },
    {
        "id": 6,
        "label": "Other Professional Degree",
        "value": "OtherProfessionalDegree"
    },
    {
        "id": 6,
        "label": "Other Non Professional Degree",
        "value": "OtherNonProfessionalDegree"
    }
];

export const optionsLeadOccupation = [
    { label: "Administrative Clerical", value: "AdministrativeClerical" },
    { label: "Architect", value: "Architect" },
    { label: "Business Owner", value: "BusinessOwner" },
    { label: "Certified Public Accountant", value: "CertifiedPublicAccountant" },
    { label: "Clergy", value: "Clergy" },
    { label: "Construction Trades", value: "ConstructionTrades" },
    { label: "Dentist", value: "Dentist" },
    { label: "Disabled", value: "Disabled" },
    { label: "Engineer", value: "Engineer" },
    { label: "Homemaker", value: "Homemaker" },
    { label: "Lawyer", value: "Lawyer" },
    { label: "Manager Supervisor", value: "ManagerSupervisor" },
    { label: "Military Enlisted", value: "MilitaryEnlisted" },
    { label: "Military Officer", value: "MilitaryOfficer" },
    { label: "Minor Not Applicable", value: "MinorNotApplicable" },
    { label: "Physician", value: "Physician" },
    { label: "Professor", value: "Professor" },
    { label: "Professional Salaried", value: "ProfessionalSalaried" },
    { label: "Retail", value: "Retail" },
    { label: "Retired", value: "Retired" },
    { label: "Sales Inside", value: "SalesInside" },
    { label: "Sales Outside", value: "SalesOutside" },
    { label: "School Teacher", value: "SchoolTeacher" },
    { label: "Scientist", value: "Scientist" },
    { label: "Self Employed", value: "SelfEmployed" },
    { label: "Skilled Semi Skilled", value: "SkilledSemiSkilled" },
    { label: "Student", value: "Student" },
    { label: "Unemployed", value: "Unemployed" },
    { label: "Other Non Technical", value: "OtherNonTechnical" },
    { label: "Other Technical", value: "OtherTechnical" }
];

export const optionsPrimaryUse = [
    { label: "Business", value: "Business" },
    { label: "Commute", value: "Commute" },
    { label: "Farm", value: "Farm" },
    { label: "Pleasure", value: "Pleasure" },
]

export const optionsGarageType = [
    { label: "Attached One Car", value: "AttachedOneCar" },
    { label: "Attached Two Car", value: "AttachedTwoCar" },
    { label: "Attached Three Car", value: "AttachedThreeCar" },
    { label: "Attached Four Car", value: "AttachedFourCar" },
    { label: "Detached One Car", value: "DetachedOneCar" },
    { label: "Detached Two Car", value: "DetachedTwoCar" },
    { label: "Detached Three Car", value: "DetachedThreeCar" },
    { label: "Detached Four Car", value: "DetachedFourCar" },
    { label: "Carport", value: "Carport" },
    { label: "No Garage", value: "NoGarage" },
    { label: "Other", value: "Other" },
]

export const optionsVehicleOwnership = [
    { label: "Owned", value: "Owned" },
    { label: "Financed", value: "Financed" },
    { label: "Leased", value: "Leased" }
]

export const optionsTypeOfEntity = [
    { label: "Sole Proprietorship", value: "Sole Proprietorship" },
    { label: "Partnership", value: "Partnership" },
    { label: "Limited Liability Companie (LLC)", value: "Limited Liability Companie (LLC)" },
    { label: "Corporation", value: "Corporation" }
];

export const optionsRevenueOrPayRoll = [
    { label: "Below $100,000", value: "Below $100,000" },
    { label: "$100,000 - $2,50,000", value: "$100,000 - $2,50,000" },
    { label: "$2,50,000 - $5,00,000", value: "$2,50,000 - $5,00,000" },
    { label: "Above $5,00,000", value: "Above $5,00,000" }
]

export const optionsPersonalInformation = [
    { label: "The categories of Personal Information you have on file about me", value: 'The categories of Personal Information you have on file about me' },
    { label: "The categories of Personal Information you have on file about me", value: 'The specific pieces of my Personal Information you have on file' },
]

export const optionsTrueFalse = [
    { label: "Yes", value: true },
    { label: "No", value: false },
]

export const optionsMaritalStatus = [
    { label: "Single", value: "Single" },
    { label: "Married", value: "Married" },
    { label: "Divorced", value: "Divorced" },
    { label: "Widowed", value: "Widowed" },
    { label: "Domestic Partner", value: "Domestic Partner" }
]

export const optionsCreditRating = [
    { label: "Poor", value: "Poor" },
    { label: "Average", value: "Average" },
    { label: "Good", value: "Good" },
    { label: "Excellent", value: "Excellent" }
]

export const optionsLicenseStatus = [
    { label: "Active", value: "Active" },
    { label: "Suspended", value: "Suspended" },
    { label: "Learner", value: "Learner" },
    { label: "International", value: "International" },
    { label: "Restricted", value: "Restricted" },
    { label: "Temporary", value: "Temporary" },
    { label: "Probation", value: "Probation" },
    { label: "Prob/Negl", value: "Prob/Negl" }
]

export const optionsGender = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" },
    { label: "Non-binary", value: "Non-binary" },
]

export const methodsOfQuestions = [
    { label: "Both", value: "Both" },
    { label: "Phone", value: "Phone" },
    { label: "Email", value: "Email" },
]

export const receiveInfoVia = [
    { label: "Phone", value: "Phone" },
    { label: "Email", value: "Email" },
]

export const optionsViolationDesc = [ //violation desc
    { label: 'Child Seat', value: 'Child Seat', violationType: 'Ticket', violation_id: 1 },
    { label: 'Failure to Stop', value: 'Failure to Stop', violationType: 'Ticket', violation_id: 1 },
    { label: 'Illegal U-turn', value: 'Illegal U-turn', violationType: 'Ticket', violation_id: 1 },
    { label: 'Seat Belt', value: 'Seat Belt', violationType: 'Ticket', violation_id: 1 },
    { label: 'Other Minor', value: 'Other Minor', violationType: 'Ticket', violation_id: 1 },
    { label: 'Other Yield', value: 'Other Yield', violationType: 'Ticket', violation_id: 1 },
    { label: 'Speed Contest/Exhibition', value: 'Speed Contest/Exhibition', violationType: 'Ticket', violation_id: 1 },
    { label: 'Speeding', value: 'Speeding', violationType: 'Ticket', violation_id: 1 },
    { label: 'Speeding Over 100', value: 'Speeding Over 100', violationType: 'Ticket', violation_id: 1 },
    { label: 'Reckless Driving - injury', value: 'Reckless Driving - injury', violationType: 'Accident', violation_id: 2 },
    { label: 'Reckless Driving - no Injury', value: 'Reckless Driving - no Injury', violationType: 'Accident', violation_id: 2 },
    { label: 'Hit and Run - Injury', value: 'Hit and Run - Injury', violationType: 'Accident', violation_id: 2 },
    { label: 'Hit and Run - no Injury', value: 'Hit and Run - no Injury', violationType: 'Accident', violation_id: 2 },
    { label: 'Chargeable Accident - no Injury', value: 'Chargeable Accident - no Injury', violationType: 'Accident', violation_id: 2 },
    { label: 'Chargeable Accident - Injury', value: 'Chargeable Accident - Injury', violationType: 'Accident', violation_id: 2 },
    { label: 'Non-Chargeable Accident', value: 'Non-Chargeable Accident', violationType: 'Accident', violation_id: 2 },
    { label: 'Distracted Driving', value: 'Distracted Driving', violationType: 'Claim', violation_id: 3 },
    { label: 'Texting while Driving', value: 'Texting while Driving', violationType: 'Claim', violation_id: 3 },
    { label: 'Drunk Driving - Injury', value: 'Drunk Driving - Injury', violationType: 'DUI', violation_id: 4 },
    { label: 'Drunk Driving - no Injury', value: 'Drunk Driving - no Injury', violationType: 'DUI', violation_id: 4 },
    { label: 'Suspension', value: 'Suspension', violationType: 'License Suspension', violation_id: 5 },
    { label: 'Driving While Suspended/Revoked', value: 'Driving While Suspended/Revoked', violationType: 'License Suspension', violation_id: 5 }
]

export const optionsViolationTypes = [ //violation type
    {
        value: 1,
        label: "Ticket",
    },
    {
        value: 2,
        label: "Accident"
    },
    {
        value: 3,
        label: "Claim"
    },
    {
        value: 4,
        label: "DUI"
    },
    {
        value: 5,
        label: "License Suspension"
    }
]

export const findViolationTypeFromID = (id) => {
    const selectedOption = optionsViolationTypes.find(option => option.value === id);
    const violationType = selectedOption ? selectedOption.label : '';
    return (
        violationType
    );
}

export const AGENT_BAR_GRAPH_COLOR = '#e73989'
export const CUSTOMER_BAR_GRAPH_COLOR = '#2f9ee9'
